// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-o_fT","advertDetailContactItem__link":"c-o_fU"};